const BigNumber = require('bignumber.js');

export const maticToWei = (price)=>{
    const decimalsPerToken = new BigNumber(10).pow(18);
    return new BigNumber(price).multipliedBy(decimalsPerToken).toString();
}